<tc-file-select [disabled]="uploading$ | async" [accept]="'image/*'" (selected)="onFileSelect($event)"
  [ngSwitch]="uploading$ | async">
  <ng-container *ngSwitchCase="true" i18n="@@storage.upload.uploading">UPLOADING</ng-container>
  <ng-container *ngSwitchCase="false">
    {{ current ? 'CHANGE' : 'UPLOAD' }}
  </ng-container>
</tc-file-select>
